import { securityAPI } from '@/utils/api'

export async function filterMessage(content) {
  const result = await securityAPI.processFiltering(content);
  // predictions 배열도 함께 반환
  return {
    filtered: result.result || content,
    predictions: result.data?.data?.predictions || []
  };
} 